import _UnassignedReader from './model';

const UnassignedReader = _UnassignedReader;

export default UnassignedReader;



// WEBPACK FOOTER //
// ./data/Reader/UnassignedReader/index.js